import Axios from "axios";
import {
    SET_PROJECT_ACTIVITY_LIST,
    UNSET_PROJECT_ACTIVITY_LIST,
} from "@/store/mutation-types";
import { saveUpdateProjectActivity, getProjectActivityList } from "@/store/api";
// initial state
const state = {
    getProjectActivityList: [],
};

const getters = {
    getProjectActivityList(state) {
        return state.getProjectActivityList;
    },
};

const mutations = {
    [SET_PROJECT_ACTIVITY_LIST](state, data) {
        state.getProjectActivityList = data;
    },
    [UNSET_PROJECT_ACTIVITY_LIST](state) {
        state.getProjectActivityList = [];
    },

};

const actions = {

    saveUpdateProjectActivity({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateProjectActivity, data)
                .then(function (response) {
                resolve(response);
                })
                .catch(function (error) {

                reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
            });
    },

    getProjectActivityList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getProjectActivityList, data)
                .then(function (response) {
                commit('SET_PROJECT_ACTIVITY_LIST', response.data.data)
                resolve(response);
                })
                .catch(function (error) {
                commit('UNSET_PROJECT_ACTIVITY_LIST')
                reject(error);
                })
                .then((always) => {
                });
            });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};